import React from "react";
import "./inputBox.css";
import TextField from "@mui/material/TextField";
import { createTheme, ThemeProvider } from "@mui/material";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";
import { prefixer } from "stylis";
import rtlPlugin from "stylis-plugin-rtl";

const InputBox = React.forwardRef((props, ref) => {
  const styles = () => {
    let mt = "70px";
    if (props.gap) {
      mt = props.gap;
    }

    let w = "100%";
    if (props.width) {
      w = props.width;
    }

    return {
      marginTop: mt,
      width: w,
    };
  };

  const theme = createTheme({
    direction: "rtl",
  });

  const cacheRtl = createCache({
    key: "muirtl",
    stylisPlugins: [prefixer, rtlPlugin],
  });

  return (
    <div className="log_sign-input-container" style={styles()}>
      <CacheProvider value={cacheRtl}>
        <ThemeProvider theme={theme}>
          <TextField
            label={props.label}
            variant="standard"
            fullWidth
            className="form-input"
            type={props.type}
            id={props.name}
            inputRef={ref}
            defaultValue={props.defaultValue ? props.defaultValue : ""}
            placeholder={props.placeHolder ? props.placeHolder : ""}
            inputProps={{
              style: {
                fontFamily: props.persianNum ? "kalameh-num" : "kalameh-light",
                textAlign: props.center ? "center" : "right",
              },
              maxLength: props.maxChar ? props.maxChar : "",
            }}
          />
        </ThemeProvider>
      </CacheProvider>
      {/* <input 
            type={props.type} 
            name={props.name} 
            id={props.name} 
            className="log_sign-input"
            required
        />
        <label htmlFor={props.name} className="input-label">
            {props.label}
        </label> */}
    </div>
  );
});

export default InputBox;
